import React, { useEffect, useRef, useState } from "react";
import "../styles/Services.css";
import { FaLaptop, FaChartLine, FaMobileAlt, FaBook, FaMicroscope, FaChalkboardTeacher, FaMicrophone } from "react-icons/fa";
import ServicesDecoration from "../images/islamic.png"; // Replace with your decoration image

const Services = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // Intersection Observer for detecting visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const services = [
    {
      icon: <FaLaptop />,
      title: "LMS Deployment and Maintenance",
      description: "Tailored Learning Management System solutions to streamline education and administration.",
    },
    {
      icon: <FaChartLine />,
      title: "Digital SEO & Marketing",
      description: "Boost your institution's online presence with expert digital marketing strategies.",
    },
    {
      icon: <FaMobileAlt />,
      title: "Digital Applications",
      description: "Custom applications designed to enhance interactive learning experiences.",
    },
    {
      icon: <FaBook />,
      title: "Content Creation",
      description: "High-quality educational materials aligned with Islamic principles.",
    },
    {
      icon: <FaMicroscope />,
      title: "STEM Activities",
      description: "Innovative STEM programs integrating Islamic perspectives.",
    },
    {
      icon: <FaChalkboardTeacher />,
      title: "Professional Development",
      description: "Training programs for educators, fostering leadership and growth.",
    },
    {
      icon: <FaMicrophone />,
      title: "Speaker Engagements",
      description: "Inspiring speaker sessions to motivate students and educators.",
    },
  ];

  return (
    <section className="services-section" ref={sectionRef}>
      <div className="services-container">
        <h2 className="services-heading">Empowering Through Services</h2>
        <p className="services-subheading">
          Qibla provides innovative, tailored solutions to uplift Islamic schools and educational institutions worldwide.
        </p>
        <div className={`services-grid ${isVisible ? "fade-in" : ""}`}>
          {services.map((service, index) => (
            <div key={index} className="service-item">
              <div className="service-icon">{service.icon}</div>
              <div className="service-info">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {isVisible && (
        <img
          src={ServicesDecoration}
          alt="Decorative Illustration"
          className="services-decoration"
        />
      )}
    </section>
  );
};

export default Services;
